<template>
  <v-dialog v-model="value" max-width="1000" scrollable persistent>
    <v-card v-if="influencer">
      <div class="text-xs-right">
        <v-btn fab small flat :loading="loading" @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 sm12 class="form-control" :class="{ 'has-error': errors.has('image') }">
            <uploadfile
              v-model="influencer.jsonvalue.image_url"
              v-validate="'required'"
              data-vv-as="Image"
              :height="150"
              :data-vv-name="'image'"
              style="width: 150px; margin: auto"
              @onUploaded="onUploaded"
            ></uploadfile>
            <div v-if="errors.has('image')" class="text-error text-xs-center error--text">
              {{ errors.first('image') }}
            </div>
          </v-flex>

          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('userid') }">
            <label for>{{ $t('Username') }}</label>
            <div v-if="influencer.id" class="primary--text">
              {{ influencer.userid }}
            </div>
            <template v-else>
              <input
                v-model.lazy="influencer.userid"
                v-validate="`required`"
                type="text"
                name="userid"
                :placeholder="$t('Username')"
                :data-vv-as="$t('Username')"
                class="form-control"
                maxlength="255"
              />
            </template>

            <span v-if="errors.has('userid')" class="text-error">{{ errors.first('userid') }}</span>
          </v-flex>

          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('password') }"
          >
            <label for>{{ $t('Password') }}</label>
            <div></div>
            <v-btn v-if="!editpassword" flat small color="primary" @click="editpassword = true"
              >Change Password</v-btn
            >
            <template v-else>
              <input
                v-model.lazy="influencer.password"
                v-validate="'required'"
                type="password"
                name="password"
                :placeholder="$t('Password')"
                :data-vv-as="$t('Password')"
                class="form-control"
                maxlength="255"
              />
              <span v-if="errors.has('password')" class="text-error">{{
                errors.first('password')
              }}</span>
            </template>
          </v-flex>

          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('line_notify_token') }"
          >
            <label for>{{ $t('Line Notify') }}</label>
            <template>
              <input
                v-model.lazy="influencer.line_notify_token"
                type="text"
                name="line_notify_token"
                :placeholder="$t('Line Notify')"
                :data-vv-as="$t('Line Notify')"
                class="form-control"
                maxlength="255"
              />
            </template>
          </v-flex>
        </v-layout>

        <div class="font-weight-bold mt-2 mb-2">สิทธิ์การเข้าถึงสินค้า</div>

        <div class="caption">ค้นหาสินค้า / ร้านค้า</div>
        <div class="form-control">
          <input
            v-model="search"
            type="text"
            :placeholder="'ค้นหาสินค้า / ร้านค้า'"
            maxlength="255"
          />
        </div>

        <div>จำนวนสินค้าที่เลือก {{ totalSelected }} ชิ้น</div>

        <v-treeview
          v-model="tree"
          :search="search"
          :filter="filter"
          :load-children="getAllProducts"
          :items="items"
          activatable
          active-class="grey lighten-4 indigo--text"
          selected-color="primary"
          open-on-click
          selectable
          expand-icon="arrow_drop_down"
          on-icon="check_box"
          off-icon="check_box_outline_blank"
          indeterminate-icon="indeterminate_check_box"
        >
        </v-treeview>

        <div class="text-xs-center">
          <v-btn outline color="grey" :loading="loading" @click="$emit('input', false)">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn depressed color="primary" :loading="loading" @click="saveInfluencer">
            {{ $t('Save') }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import uploadfile from '@/components/elements/uploadfile'

const dict = {
  en: {
    custom: {
      userid: {
        excluded: 'Duplicate Userid'
      }
    }
  },
  th: {
    custom: {
      userid: {
        excluded: 'Username ซ้ำ'
      }
    }
  },
  la: {
    custom: {
      userid: {
        excluded: 'ເຮັດຊ້ໍາ Username'
      }
    }
  }
}

export default {
  props: {
    value: {
      default: false
    },
    data: {
      default: () => {
        return {
          userid: '',
          password: '',
          productidlist: [],
          jsonvalue: {
            image_url: ''
          }
        }
      }
    },
    influencers: {
      default: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct',
      categories: 'getCategories',
      loadingCategories: 'getLoadingCategory'
    }),
    filter() {
      return (item, search, textKey) =>
        item[textKey].toLowerCase().indexOf(search.toLowerCase()) > -1
    },
    totalSelected() {
      return this.tree.filter((el) => {
        return el && !el.toString().includes('notinclude:')
      }).length
    },
    influencerName() {
      return this.influencers
        .filter((el) => {
          if (this.influencer && this.influencer.id) {
            return this.influencer.id != el.id
          } else {
            return true
          }
        })
        .map((el) => {
          return el.userid
        })

        .join(',')
    }
  },
  components: {
    uploadfile
  },
  data() {
    return {
      influencer: null,
      items: [],
      tree: [],
      search: '',
      treeproducts: [],
      treecategories: [],
      items: [],
      loading: false,
      editpassword: true
    }
  },
  mounted() {
    this.$validator.localize(dict)
    this.influencer = this.data
    this.treecategories = this.categories
      .reduce((acc, cur) => {
        var found = acc.find((el) => {
          return el.id == cur.id
        })

        if (!found) acc.push(cur)

        return acc
      }, [])
      .sort((a, b) => {
        var nameA = a.name.toUpperCase() // ignore upper and lowercase
        var nameB = b.name.toUpperCase() // ignore upper and lowercase
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
    this.items = this.getTree()
    if (this.influencer.id >= 0) {
      this.editpassword = false
      this.tree = this.data.productidlist
    }
  },
  methods: {
    lineNotifyLink() {
      return (
        'https://notify-bot.line.me/oauth/authorize?response_type=code&client_id=vf6yxOil8ZhEDPxgKtZd6c&redirect_uri=' +
        window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '') +
        '/linenotify&scope=notify&state=influ|' +
        this.influencer.id
      )
    },
    onUploaded() {},
    async getAllProducts() {
      //   var response = await api.getAllProducts()
      //   this.flows = response.data ? response.data : []
      this.treeproducts = this.products
    },
    getTree() {
      const children = this.treecategories
        .map((cat) => {
          if (cat) {
            var c = this.getChildren(cat.id)
            if (c.length > 0) {
              return {
                id: 'notinclude:' + cat.id,
                name: this.getName(cat.name),
                children: this.getChildren(cat.id)
              }
            } else {
              return null
            }
          }
        })
        .filter((el) => {
          return el != null
        })
      return [
        {
          id: 'notinclude:all',
          name: 'All Category',
          children
        }
      ]
    },
    getName(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    },
    getChildren(catid) {
      const products = this.products
        .filter((product) => {
          return product.categoryid == catid && product.categoryid != null
        })
        .map((el) => {
          return {
            ...el,
            id: el.id.toString(),
            name: this.getName(el.name)
          }
        })

      return products.sort((a, b) => {
        return a.name > b.name ? 1 : -1
      })
    },
    async saveInfluencer() {
      var vm = this

      let result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.loading = true
      var influencer = {
        ...this.influencer,
        productidlist: this.tree.filter((el) => {
          return el && !el.toString().includes('notinclude:')
        })
      }
      this.$emit('saveInfluencer', {
        influencer: influencer,
        oncomplete: () => {
          return new Promise((resolve) => {
            vm.$emit('input', false)
            vm.loading = false
            resolve()
          })
        },
        onerror: (error) => {
          vm.$swal.fire({
            type: 'error',
            title: error
          })
          vm.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/influencer/InfluencerManage.vue